module.exports = __webpack_public_path__ + "img/she_killed_in_ecstasy_soledad_tablet.14dc7bb0.jpg";